var exports = {
  "kL": "x52a3aa3b--5140d3--container",
  "ci": "x52a3aa3b--5140d3--large-container",
  "AE": "x52a3aa3b--5140d3--middle-container",
};

module.exports = exports;
